export enum Command {
    Failed,
    Start,
    End
}
